<div class="toast toast--{{ mainColor }}" role="alert" attr.aria-live="getAriaLive()" aria-atomic="true">
  @if (iconName) {
  <a360-icon
    width="24px"
    color="icon-{{ mainColor }}"
    height="24px"
    class="toast__icon"
    [icon]="iconName"
    aria-hidden="true"
  ></a360-icon>
  }

  <div class="toast__content">
    @if (title()) {
    <p class="toast__title">{{ title() }}</p>
    } @if (message()) {
    <p class="toast__message">{{ message() }}</p>
    }
  </div>

  @if (closable) {
  <button type="button" aria-label="Close" class="toast__close-button" (click)="close()">
    <a360-icon width="16px" height="16px" color="icon-grey" icon="cross" aria-hidden="true"></a360-icon>
  </button>
  }
</div>
